import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'split',
})
export class SplitPipe implements PipeTransform {
  transform(text: string, by: string, index: number = 0) {
    if (text != null && text != '') {
      let arr = text?.split(by);
      return arr[index];
    } else {
      return '';
    }
  }
}
